<template>
  <v-card class="mx-auto">
    <v-app-bar
      color="primary"
      dark
      elevate-on-scroll
      scroll-target="#scrolling-techniques-7"
    >
      <v-toolbar-title>Journal entries</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn fab dark small outlined  elevation="2"
        raised  @click="addNewJournal">
        <v-icon>mdi-book-plus</v-icon>
      </v-btn>
      <v-btn icon dark @click="closeDial">
        <v-icon color="red">mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <v-sheet
      id="scrolling-techniques-7"
      class="overflow-y-auto primary"
      max-height="600"
    >
      <v-card v-for="journal in alljournals" :key="journal.JH_JNo" class="ma-1">
        <v-btn
          dark
          color="primary"
          style="position: absolute; right: 0px;"
          class="ma-5"
          icon
        >
          <v-icon dark v-if="journal.JH_FlwUpType == 'Call'">
            mdi-phone-outgoing
          </v-icon>
          <v-icon dark v-else-if="journal.JH_FlwUpType == 'Visit'">
            mdi-handshake
          </v-icon>
          <v-icon dark v-else>
            mdi-email
          </v-icon>
        </v-btn>
        <v-card-title>
          {{ journal.JH_ContPerson }}
        </v-card-title>
        <v-card-subtitle height="600">
          <small class="grey--text">{{ journal.JH_JTS }}</small>
        </v-card-subtitle>
        <v-card-text>
          {{ journal.JH_Remarks }}
          - {{ journal.JH_JByName }}
        </v-card-text>
      </v-card>
      <v-divider inset></v-divider>
    </v-sheet>
  </v-card>
</template>

<script>
export default {
  props: ["customer"],
  data: () => ({}),
  computed: {
    alljournals() {
      return this.$store.getters.alljournals;
    },
  },
  methods: {
    addNewJournal() {
      this.$emit("addNewJournal");
    },
    closeDial(){
      this.$emit("close");
    }
  },
  created() {},
};
</script>
